import ClientSuspense from '@components/ClientSuspense'
import formatNumber from '@i18n/formatNumber'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'

import {useOrderLoyaltyInfo} from '../hooks/useLoyaltyInfo.royalty'

import AddToWallets from './Download'
import LoyaltySkeleton from './LoyaltySkeleton'

function TrackingLoyaltyInner() {
  const {order} = useOrder()
  const card = useOrderLoyaltyInfo(order?.websiteCoinsGiven ? order.websiteId : null)
  if (!card) return null

  return (
    <div
      className="rounded-xl shadow-lg p-4 space-y-4 my-5"
      style={{
        backgroundColor: card.backgroundColor,
        color: card.textColor
      }}>
      <div className="flex items-center -mt-2">
        <img src={card.logoURL} alt={card.websiteName} className="max-h-14 max-w-[180px] h-full" />
        <div className="flex-1"></div>
        <div className="text-right">
          <div className="text-sm" style={{color: card.secondaryColor}}>
            {card.coinsName}
          </div>
          <div>{formatNumber(card.balance, '0,0.[00]')}</div>
        </div>
      </div>
      <div className="text-center">
        <div>
          <div className="text-sm" style={{color: card.secondaryColor}}>
            Acumulaste con este pedido
          </div>
          <div>
            {formatNumber(order?.websiteCoinsGiven, '0,0.[00]')} {card.coinsName}
          </div>
        </div>
      </div>
      <AddToWallets card={card} />
    </div>
  )
}

export default function TrackingLoyalty() {
  return (
    <ClientSuspense fallback={<LoyaltySkeleton />}>
      <TrackingLoyaltyInner />
    </ClientSuspense>
  )
}
